(() => {
    const header = document.querySelector('.header.wrapper');
    const innerContainer = document.querySelector('.hcmenu');
    const outerContainer = document.querySelector('.hcdesktopnavigation');
    function fixMenuOverlap() {
        document.body.classList.add('hc-header-desktop');
        if (innerContainer.clientWidth > outerContainer.clientWidth - 20) {
            document.body.classList.remove('hc-header-desktop');
        } else {
            document.body.classList.add('hc-header-desktop');
        }
        header.style.opacity = '1';
    }

    document.addEventListener('DOMContentLoaded', function() {
        fixMenuOverlap();
    });
    window.addEventListener('resize', function() {
        fixMenuOverlap();
    });
})();
/*
 *
 *document.addEventListener('DOMContentLoaded', function() {
 *    if (window.innerWidth > 768) {
 *        var parentContainer = document.querySelector('.header.wrapper');
 *        var containerHeight = parentContainer.clientHeight;
 *
 *        if (containerHeight > 55) {
 *            document.querySelector('body').classList.remove('hc-header-desktop');
 *            parentContainer.style.opacity = '1';
 *        } else {
 *            parentContainer.style.opacity = '1';
 *        }
 *    }
 *});
 *
 *window.onresize = function() {
 *    if (window.innerWidth > 768) {
 *        var parentContainer = document.querySelector('.header.wrapper');
 *        var containerHeight = parentContainer.clientHeight;
 *
 *        console.log(containerHeight);
 *
 *        if (containerHeight > 55) {
 *            document.querySelector('body').classList.remove('hc-header-desktop');
 *            parentContainer.style.opacity = '1';
 *        } else {
 *            parentContainer.style.opacity = '1';
 *        }
 *    }
 *};
 */
